/* eslint-disable no-underscore-dangle */
/**
 * - Triggers pebble-post mail event, if present.
 * - PebblePost is initialized through GTM, and may not always be
 *   present, so takes an extremely conservative approach.
 */
const triggerPebblePost = () => {
  if (
    typeof window !== 'undefined' &&
    typeof window._pp !== 'undefined' &&
    typeof window._pp.mailEvent === 'function'
  ) {
    window._pp.mailEvent();
  }
};
/* eslint-enable */

export default triggerPebblePost;
